function load(component) {
    return () => import(`@/components/${component}.vue`);
}
export default {
    path: "stock",
    component: load("stock/layout"),
    children: [
        {
            path: "store",
            name: "stockStore",
            component: load("stock/store/index"),
            meta: {
                parent: "stock",
                child: "inventory",
                deal: false
            }
        },
        {
            path: "store/create",
            name: "stockStore-create",
            component: load("stock/store/create"),
            meta: {
                parent: "stock",
                child: "inventory",
                deal: true
            }
        },
        {
            path: "store/details/:id",
            name: "stockStore-details",
            component: load("stock/store/details"),
            meta: {
                parent: "stock",
                child: "inventory",
                deal: false
            }
        },
        {
            path: "store/history/:id",
            name: "stockStore-history",
            component: load("stock/store/history"),
            meta: {
                parent: "stock",
                child: "inventory",
                deal: false
            }
        },
        {
            path: "pushstore",
            name: "stockPush",
            component: load("stock/pushStore/index"),
            meta: {
                parent: "stock",
                child: "input",
                deal: false
            }
        },
        {
            path: "pushstore/create",
            name: "stockPush-create",
            component: load("stock/pushStore/create"),
            meta: {
                parent: "stock",
                child: "input",
                deal: true
            }
        },
        {
            path: "pushstore/details/:id",
            name: "stockPush-details",
            component: load("stock/pushStore/details"),
            meta: {
                parent: "stock",
                child: "input",
                deal: false
            }
        },
        {
            path: "popstore",
            name: "stockPop",
            component: load("stock/popStore/index"),
            meta: {
                parent: "stock",
                child: "output",
                deal: false
            }
        },
        {
            path: "popstore/create",
            name: "stockPop-create",
            component: load("stock/popStore/create"),
            meta: {
                parent: "stock",
                child: "output",
                deal: true
            }
        },
        {
            path: "popstore/details/:id",
            name: "stockPop-details",
            component: load("stock/popStore/details"),
            meta: {
                parent: "stock",
                child: "output",
                deal: false
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/components/stock/route/index.js